import { RightOutlined } from '@ant-design/icons';
import { EImportSectionsTarget } from '@constants';
import { ISection } from '@sdk/contracts';
import { Collapse } from 'antd';
import { useTheme } from 'styled-components';

import { IntroductionActivities } from '@/components/IntrouctionSection/IntroductionActivities';
import { SectionActions } from '@/components/SectionActions';
import { SectionName } from '@/components/SectionName';
import { useCourseDetail } from '@/store';

type Props = {
  section: ISection;
  isOpen: boolean;
  onToggle: (sectionId: string) => void;
};

export const IntroductionSectionItem: React.FC<Props> = ({ section, isOpen, onToggle }) => {
  const { course } = useCourseDetail();
  const { colors } = useTheme();

  if (!course) return null;

  return (
    <Collapse
      key={section._id}
      activeKey={isOpen ? [section._id] : []}
      onChange={() => onToggle(section._id)}
      expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}>
      <Collapse.Panel
        key={section._id}
        header={<SectionName section={section} />}
        extra={
          <SectionActions
            courseId={course._id}
            section={section}
            target={EImportSectionsTarget.INTRODUCTION}
          />
        }
        style={{
          backgroundColor: section.active ? colors.black1 : colors.black2,
          borderRadius: 8
        }}>
        <IntroductionActivities section={section} fetchOnlyParentsCourses />
      </Collapse.Panel>
    </Collapse>
  );
};
